import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { WebHook } from '@wdx/clmi/clmi-swagger-gen';
import { PaginatedApiResponse } from '@wdx/clmi/api-services/models';
import { Observable } from 'rxjs';
import { PaginationOptions } from '../../models/pagination-options';
import { ApiPaginationService } from '@wdx/shared/infrastructure/api-service';
import { ConfigService } from '../../services/config.service';

@Injectable()
export class WebhooksService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);
    private apiPaginationService = inject(ApiPaginationService);


    loadAllWebHooks(
        paginationOptions: PaginationOptions,
    ): Observable<PaginatedApiResponse<WebHook>> {
        return this.http.get<PaginatedApiResponse<WebHook>>(
            `${this.config.getConfiguration().API_BASE}/webhook`,
            {
                headers:
                    this.apiPaginationService.mapPaginationOptions(
                        paginationOptions,
                    ),
            },
        );
    }
}
